/** Rutas base del equipo — no requieren módulo Gestión Despacho. */
export const EQUIPO_USUARIOS_PATH = "/equipo/usuarios";
export const EQUIPO_CHAT_PATH = "/equipo/chat";

export const EQUIPO_BASE_PATHS = new Set([EQUIPO_USUARIOS_PATH, EQUIPO_CHAT_PATH]);

export function isEquipoBasePath(pathname) {
  const path = String(pathname || "").split("?")[0];
  if (EQUIPO_BASE_PATHS.has(path)) return true;
  return path.startsWith("/equipo/");
}
